/* eslint-disable no-empty-pattern */
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { Loader, Table } from '../../../../../common/components';
import { trustDyanamicItemWisePayementsSections } from '../../../../../utils/constant';
import { formatPrice } from '../../../../../utils/formatters';
import ItemEmptyTile from '../../../../reports/item-empty-tile/item-empty-tile';
import TrustLegend from '../../trustLegend/TrustLegend';

export default forwardRef(function PaidTable(_obj, ref) {
  const [loading, setLoading] = useState(false);
  const [totaldata, settotalData] = useState([]);

  useImperativeHandle(ref, () => ({ getProjectionData }));

  const getProjectionData = (err, res) => {
    if (err) return setLoading(false);

    // eslint-disable-next-line no-shadow
    const { loading, data } = res || {};

    setLoading(loading);

    if (loading) return;

    const { getProjection } = data || {};
    settotalData(getProjection?.data?.result);
  };

  const spaceFiller = (key, length, padding, fillWith) => {
    return Array(length)
      .fill(0)
      .slice(padding)
      .map((_val, index) => <td key={`${key}-${index.toString()}`}>{fillWith || ''}</td>);
  };

  return (
    <Card className="table-paid">
      <CardHeader>
        <TrustLegend title="Paid (FactSheet)" />
      </CardHeader>
      <CardBody>
        {!loading &&
        totaldata?.paidFactSheet &&
        Object.entries(totaldata?.paidFactSheet).length > 0 ? (
          <Table
            headers={totaldata.paidFactSheet.headers}
            bordered
            responsive
            className="trustaccounts-table"
          >
            <tbody>
              {/* Finance Charges Mapping */}
              <tr>
                <td>{totaldata.paidFactSheet.financeCharges[0] || 'Finance Charges'}</td>
                <td />
                {totaldata.paidFactSheet.financeCharges.length > 0
                  ? totaldata.paidFactSheet.financeCharges
                      .slice(2)
                      .map((FCItem, index) => (
                        <td key={`fc-${index.toString()}`}>{formatPrice(FCItem || '') || '-'}</td>
                      ))
                  : totaldata?.paidFactSheet?.headers
                      .slice(2)
                      .map((_FCItem, index) => <td key={`fc-${index.toString()}`}>-</td>)}
              </tr>
              {/* Tax Mapping */}
              <tr>
                <td>{totaldata.paidFactSheet.tax[0] || 'Total Sales Tax'}</td>
                <td />
                {totaldata.paidFactSheet.tax.slice(2).map((taxItem, index) => (
                  <td key={`t-${index.toString()}`}>{formatPrice(taxItem || '') || '-'}</td>
                ))}
                {spaceFiller(
                  'tax',
                  totaldata.paidFactSheet.headers.length,
                  totaldata.paidFactSheet.tax.length || 2,
                  '-',
                )}
              </tr>
              {/* Sections Mapping */}
              {trustDyanamicItemWisePayementsSections.map((section) => {
                return (
                  totaldata?.paidFactSheet?.[section?.keyTobeMapped].length > 0 && (
                    <>
                      <tr className="row-spacer">
                        <td className="font-heavy">{section?.title}</td>
                        {spaceFiller('properties', totaldata.paidFactSheet.headers.length, 1)}
                      </tr>
                      {totaldata?.paidFactSheet?.[section?.keyTobeMapped].map((item, index) => (
                        <tr key={`${section.keyTobeMapped}-p-${index.toString()}`}>
                          <td>
                            {item[0].split('\n').length > 1 ? (
                              <>
                                {item[0].split('\n')[0]}
                                {item[0].split('\n')[1] ? (
                                  <>
                                    <br />{' '}
                                    <small className="isTrustableText">
                                      {item[0].split('\n')[1]}
                                    </small>{' '}
                                  </>
                                ) : (
                                  ''
                                )}
                              </>
                            ) : (
                              item[0]
                            )}
                          </td>
                          {section.keyTobeMapped === 'adjustments' ||
                          section.keyTobeMapped === 'discounts' ? (
                            <td />
                          ) : (
                            <td className={`${item[1] ? 'isTrustableText' : ''}`}>
                              {item[1] ? 'Yes' : 'No'}
                            </td>
                          )}
                          <td>{formatPrice(item[2] || '0')}</td>
                          <td>{formatPrice(item[3] || '0')}</td>
                          {section.keyTobeMapped === 'adjustments' ||
                          section.keyTobeMapped === 'discounts'
                            ? spaceFiller('adjustments', totaldata.paidFactSheet.headers.length, 4)
                            : item
                                .slice(4)
                                .map((subItem, subIndex) => (
                                  <td key={`${section.keyTobeMapped}-si-${subIndex.toString()}`}>
                                    {formatPrice(subItem || '') || '-'}
                                  </td>
                                ))}
                        </tr>
                      ))}
                    </>
                  )
                );
              })}
              {/* Total Contract Mapping */}
              <tr className="row-spacer">
                <td>Total Contract</td>
                <td />
                <td>{formatPrice(totaldata.totalContract || 0)}</td>
                {spaceFiller('totalContract', totaldata.paidFactSheet.headers.length, 3)}
              </tr>
              {/* Equal Monthly Payments Mapping */}
              {totaldata?.paidFactSheet?.equalMonthlyPayments && (
                <tr>
                  <td>{totaldata?.paidFactSheet?.equalMonthlyPayments[0]}</td>
                  <td />
                  <td />
                  {totaldata?.paidFactSheet?.equalMonthlyPayments
                    .slice(2)
                    .map((EQItem, EQIndex) => {
                      return <td key={`eq-${EQIndex.toString()}`}>{formatPrice(EQItem) || ''}</td>;
                    })}
                </tr>
              )}
            </tbody>
          </Table>
        ) : (
          <ItemEmptyTile />
        )}
      </CardBody>
      {loading && <Loader />}
    </Card>
  );
});
